import { withBemMod } from '@bem-react/core';
import { cnButton } from '@ps-int/360-components/dist/components/Button';

import './style.global.css';

export interface IButtonSizeMaxProps {
    size?: 'auto';
}

export const withSizeAuto = withBemMod<IButtonSizeMaxProps>(cnButton(), {
    size: 'auto',
});
